/**
 * @name NewsService
 * @description Servicio para gestionar los avisos
 * @author César Rivera
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = Environment.getCurrent().endpoints.admin;

/**
 * Lo consulta cada usuario para ver cuales son los avisos/comunicados que tiene asignados
 * @param {any} request filter { leido }
 * @return {any} promise
 */
const getByUser = (request) => {
  let read = (request.filter.leido === false || request.filter.leido === true) ? `&leido=${request.filter.leido}` : '';
  let URL = `${BASE_URL}/AvisoEmpleado/Empleado?paginado=1,100${read}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Marcar como leídas los avisos/comunicados de administrador o sistema
 * @param {any} advice
 * @return {any} promise
 */
const markAsRead = (advice) => {
  let adviceToUpdate = {
    Id: advice.Id,
    Leido: advice.Leido
  };
  let URL = `${BASE_URL}/AvisoEmpleado/${advice.Id}`;

  return axios.put(URL, adviceToUpdate).then(({ data }) => {
    return data;
  });
};

export const NewsService = {
  getByUser,
  markAsRead
};